import { useFiltersContext } from '@openx/components-filters/lib/context/FiltersContext.tsx';
import { TopBar } from '@openx/components-table/ChipFilters/TopBar.tsx';
import { useTranslation } from 'react-i18next';
import type { CreativesListFilters } from './types.ts';

export const CreativesTopBar = () => {
  const { t } = useTranslation();
  const { onFiltersChange, criteria } = useFiltersContext<CreativesListFilters>();

  return (
    <TopBar
      filters={criteria.filters as CreativesListFilters}
      onChange={onFiltersChange}
      searchText={t('Search Name')}
      useFiltersV2
    />
  );
};
